<template>

    <div class="row no-gutters px-0 col-md-12 front-public-info-wrapper">



        <!-- Abdullah26 added mobile-align-start -->
                <div class="col-md-8 p-0 d-flex align-items-center mobile-align-start">
                    <b-avatar class="m-0" style="max-width: 200px;" variant="light" rounded button size="200px" :src="avatarsrc"></b-avatar>
                    <div class="employee-inner-content pl-4">
                        <!-- Abdullah26 commented this div  -->
                        <!-- <div> -->
                            <div class="personal-data-text-primary">{{ public_info.name }}</div>
                        <!-- </div> -->
                        <div class="personal-data-text-secondery" >
                            <template v-if="public_info.jobposition_id > 0 && public_info.department_id > 0">
                                {{public_info.jobposition}} | {{public_info.department}}
                            </template>
                        </div>
                        <div class="personal-data-wrapper mt-3">
                            <div class="personal-data-inner mb-2" v-if="public_info.email != null && public_info.email != ''">
                                <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.625 12.0056V2.40065C0.625 1.43616 1.37244 0.654297 2.29446 0.654297H15.6501C16.5721 0.654297 17.3196 1.43616 17.3196 2.40065V12.0056C17.3196 12.97 16.5721 13.7519 15.6501 13.7519H2.29446C1.37244 13.7519 0.625 12.97 0.625 12.0056Z" fill="#3A52A6"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.2955 1.30976C1.71924 1.30976 1.25209 1.79843 1.25209 2.40123V12.0061C1.25209 12.6089 1.71924 13.0976 2.2955 13.0976H15.6512C16.2274 13.0976 16.6946 12.6089 16.6946 12.0061V2.40123C16.6946 1.79843 16.2274 1.30976 15.6512 1.30976H2.2955ZM0 2.40123C0 1.07507 1.02773 0 2.2955 0H15.6512C16.9189 0 17.9467 1.07507 17.9467 2.40123V12.0061C17.9467 13.3323 16.9189 14.4074 15.6512 14.4074H2.2955C1.02773 14.4074 0 13.3323 0 12.0061V2.40123Z" fill="#3A52A6"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.888099 3.88126C1.02852 3.55075 1.39849 3.4019 1.71445 3.54879L8.88799 6.88388C8.94194 6.90896 9.00354 6.90896 9.05749 6.88388L16.231 3.54879C16.547 3.4019 16.917 3.55075 17.0574 3.88126C17.1978 4.21177 17.0555 4.59878 16.7396 4.74567L9.56602 8.08075C9.18831 8.25636 8.75717 8.25636 8.37946 8.08075L1.20593 4.74567C0.88997 4.59878 0.747674 4.21177 0.888099 3.88126Z" fill="white"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.4587 7.57341C6.39153 7.54062 6.31276 7.54757 6.25178 7.59167L1.81611 10.7995C1.5317 11.0052 1.14175 10.9308 0.945128 10.6333C0.748503 10.3358 0.819662 9.92788 1.10407 9.7222L5.53974 6.51431C5.96659 6.20561 6.51795 6.15697 6.9882 6.38653L8.88439 7.31218C8.94033 7.33948 9.00495 7.33948 9.06089 7.31218L10.9571 6.38653C11.4273 6.15697 11.9787 6.20562 12.4055 6.51431L16.8412 9.7222C17.1256 9.92788 17.1968 10.3358 17.0002 10.6333C16.8035 10.9308 16.4136 11.0052 16.1292 10.7995L11.6935 7.59167C11.6325 7.54757 11.5538 7.54062 11.4866 7.57341L9.59038 8.49906C9.19882 8.6902 8.74646 8.6902 8.3549 8.49906L6.4587 7.57341Z" fill="white"/>
                                </svg>
                                <div class="personal-data-reguler">{{public_info.email}}</div>

                            </div>
                            <div class="personal-data-inner mb-2" v-if="public_info.phone != null && public_info.phone != ''" >
                                <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.13637 3.81014L4.35484 0.862476C4.12457 0.481466 3.6344 0.350662 3.2604 0.594741C2.35068 1.18843 0.815016 2.35163 0.470848 3.62601C-0.0204565 5.44521 1.70841 8.26069 1.77082 8.36146L1.77457 8.3673C1.83995 8.46562 3.47125 10.9121 4.80974 12.2409C6.14825 13.5697 8.61262 15.1892 8.71183 15.2542L8.71774 15.2579C8.81943 15.32 11.6553 17.036 13.4878 16.5485C14.7714 16.207 15.9434 14.683 16.5418 13.7801C16.7878 13.4088 16.6561 12.9221 16.2722 12.6934L13.3029 10.9248C12.9206 10.697 12.4256 10.8076 12.1782 11.1758L11.345 12.4166C11.0902 12.7961 10.5762 12.8996 10.1995 12.6387C9.34904 12.0496 7.89864 10.9999 6.97933 10.0872C6.06011 9.1747 5.0028 7.73502 4.40939 6.89074C4.14646 6.51664 4.25094 6.00623 4.63335 5.75334L5.88321 4.92683C6.25437 4.68139 6.36582 4.18977 6.13637 3.81014Z" fill="#3A52A6"/>
                                </svg>
                                <div class="personal-data-reguler mobile-margin-top-2">{{formatPhoneNumber(public_info.phone)}}</div>

                            </div>
                            <div class="personal-data-inner personal-data-inner-address mb-2"  v-if="public_info.address != null && public_info.address != ''">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.2288 4.33647L11.0499 0.709048C9.63835 -0.281066 7.47151 -0.22706 6.11389 0.826062L1.60939 4.34547C0.710291 5.04755 0 6.48772 0 7.6218V13.8325C0 16.1278 1.86114 18 4.15385 18H13.8461C16.1389 18 18 16.1368 18 13.8415V7.73882C18 6.52372 17.2178 5.02955 16.2288 4.33647ZM9.67431 14.3996C9.67431 14.7686 9.36862 15.0747 8.99999 15.0747C8.63136 15.0747 8.32566 14.7686 8.32566 14.3996V11.6993C8.32566 11.3302 8.63136 11.0242 8.99999 11.0242C9.36862 11.0242 9.67431 11.3302 9.67431 11.6993V14.3996Z" fill="#3A52A6"/>
                                </svg>
                                <div class="personal-data-reguler mobile-margin-top-2">{{public_info.address}}</div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-md-4  p-0">
                    <dl class="row py-3 px-0 public-info-last">
                        <dt class="col-sm-7 text">Employee ID:</dt>
                        <dd class="col-sm-5 value">{{public_info.employee_code}}</dd>


                        <template v-if="public_info.date_of_birth != '0000-00-00'">
                            <dt class="col-sm-7 text">Birthday:</dt>
                            <dd class="col-sm-5 value">{{ public_info.date_of_birth }}</dd>
                        </template>

                        <dt class="col-sm-7 text">Gender:</dt>
                        <dd class="col-sm-5 value">{{public_info.gender}}</dd>

                        <template  v-if="contract_info.employee_active">
                            <dt class="col-sm-7 text">Employee Status:</dt>
                            <dd class="col-sm-5 value">Active
                                <!-- Abdullah chnaged float-left to ml-3  -->
                                <b-icon class=" ml-3" icon="check-circle-fill" variant="success"></b-icon>
                            </dd>
                        </template>
                        <template  v-else>
                            <dt class="col-sm-7 text">Employee Status:</dt>
                            <!-- Abdullah chnaged float-left to ml-3  -->
                            <dd class="col-sm-5 value">Inactive <b-icon class=" ml-3" icon="exclamation-circle-fill" variant="danger"></b-icon></dd>
                        </template>

                        <template  v-if="contract_info.contract_active">
                            <dt class="col-sm-7 text">Contract Status:</dt>
                            <dd class="col-sm-5 value">Active
                                <!-- Abdullah chnaged float-left to ml-3  -->
                                <b-icon class=" ml-3" icon="check-circle-fill" variant="success"></b-icon>
                            </dd>
                        </template>
                        <template  v-else>
                            <dt class="col-sm-7 text">Contract Status:</dt>
                            <!-- Abdullah chnaged float-left to ml-3  -->
                            <dd class="col-sm-5 value">Inactive <b-icon class=" ml-3" icon="exclamation-circle-fill" variant="danger"></b-icon></dd>
                        </template>

                    </dl>
                </div>

                <!--
                    <div class="col-sm-3 pr-3 position-relative">

                        <template v-if="show_status">
                            <div class="card px-3 status-wrapper" style="margin-top: -30px; max-width: 240px; margin-left: auto;">
                                <div class="mt-2">
                                    <div class="row no-margin employee-status-wrapper" v-if="contract_info.employee_active"><div class="col-7 px-0">Employee Status:</div> <div class="col-5 pr-0">Active <b-icon class="mt-1 float-right" icon="check-circle-fill" variant="success"></b-icon></div></div>
                                    <div class="row no-margin employee-status-wrapper" v-else><div class="col-7 px-0">Employee Status: </div><div class="col-5 pr-0">Inactive <b-icon class="mt-1 float-right" icon="exclamation-circle-fill" variant="danger"></b-icon></div></div>
                                </div>

                                <div class="mb-1">
                                    <div class="row no-margin employee-status-wrapper" v-if="contract_info.contract_active"><div class="col-7 px-0">Contract Status: </div><div class="col-5 pr-0">Active <b-icon class="mt-1 float-right" icon="check-circle-fill" variant="success"></b-icon></div></div>
                                    <div class="row no-margin employee-status-wrapper" v-else><div class="col-7 px-0">Contract Status: </div><div class="col-5 pr-0">Inactive <b-icon class="mt-1 float-right" icon="exclamation-circle-fill" variant="danger"></b-icon></div></div>
                                </div>
                            </div>
                        </template>

                        <div class="text-right position-absolute back-btn" style="bottom: 1.5rem; right: 20px;">
                            <button type="button" @click="deleteEmployee()" class="btn btn-primary btn-danger rounded p-2 d-block mb-2 w-100" v-if="this.public_info.has_contract == 'no'"><span><b-icon icon="trash" rotate="0" flip-h="" class="mr-2" scale="1"></b-icon></span><span>Delete Employee</span></button>
                            <div class="text-right d-block mb-2" v-else title="This employee can't be deleted since s/he has a contract (active/inactive)." v-b-tooltip placement="right">
                                <b-icon icon="info-circle"></b-icon>
                            </div>
                            <a :href="$api_url+'/employee'" class="btn btn-primary rounded p-2 w-100"><span><b-icon icon="reply" rotate="0" flip-h="" class="mr-2" scale="2"></b-icon></span><span>Back to List</span></a>
                        </div>


                    </div>
                -->
    </div>
</template>

<script>
    import moment from 'moment';
    export default{

        mounted() {

            this.showoverlay = false;
        },
        data(){

            return {

                public_info : [],
                contract_info : [],
                avatarsrc : '',

                showoverlay : true,

                show_status : false,

                current_employee: ''

            }
        },
        filters:{
            formatDate: function(value){
                if (value && value != '0000-00-00 00:00:00') {
                    return moment(String(value)).format('YYYY-MM-DD')
                }else{
                    value = '';
                }
            },
        },
        methods:{
            getEmployeePublicData: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/front/employee/publicinfo' , {
                    params: {

                    }
                }).then(function(response){
                    this.public_info = response.data;
                    this.current_employee = response.data.employee_id;

                    if(this.public_info.pic != '')
                        this.avatarsrc = this.$api_url+'/avatar/'+ this.public_info.company_id + '/' + this.public_info.pic;
                    else
                        this.avatarsrc = this.$api_url+'/avatar/demo.jpg';

                    if(this.public_info.status == 1) this.employee_status = true;

                    this.show_status = true;

                }.bind(this));
            },

            getEmployeeContractStatus: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/front/employee/contract-status' , {
                    params: {

                    }
                }).then(function(response){
                    this.contract_info = response.data;

                }.bind(this));
            },

            deleteEmployee: function()
            {
                if(!this.checkNet()) return false;

                let formData = new FormData();
                formData.append('employee_id', this.current_employee);

                axios.post(this.$api_url+'/front/employee/del', formData).then(function (response)
                {
                    if(response.data.success == 'Employee successfully deleted!'){
                        this.$bvToast.toast('Employee deleted successfully', {
                                                title: `Success`,
                                                variant: 'success',
                                                solid: true
                                            });
                        window.location.href = this.$api_url+'/front/employee';
                    }else{
                        this.$bvToast.toast('Error', {
                                                title: `Error`,
                                                variant: 'danger',
                                                solid: true
                                            });
                    }

                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },


        },
        created: function(){
            this.getEmployeePublicData();
            this.getEmployeeContractStatus();
        }
    }
</script>
